export default __webpack_public_path__ + "static/media/announcement-highlight-by-type-inner.6cc930df.svg";